import { TableHeaderType } from "../types/TableHeaderType";

export const VmTemplateHeader: TableHeaderType[] = [
  {
    label: "Name",
    key: "name",
    id: "name",
    sortable: true,
  },
  {
    label: "Cloud Provisioner Template",
    key: "cloudProvisionerTemplate",
    id: "cloudProvisionerTemplate.fileName",
    sortable: true,
  },
  {
    label: "Cloud Environment",
    key: "cloudEnvironment.cloudProvider.cloudProviderName",
    id: "cloudEnvironment.cloudProvider.cloudProviderName",
    sortable: true,
  },
  {
    id: "creationDate",
    label: "Creation Date",
    sortable: true,
    key: "creationDate",
  },
];
